import * as Sentry from '@sentry/browser';

const config = window.__CONFIG__;

// Artifact metadata is replaced by the client build.
Sentry.init({
  dsn: 'https://af94fa58def4709c81d5a6c2b9f9bf6a@o37417.ingest.us.sentry.io/4510866135252992',
  release: [process.env.ARTIFACT_ID, process.env.ARTIFACT_VERSION].join('@'),
  environment: config.environment,
  enabled: true,
  sampleRate: 1.0,
  tracesSampleRate: 1.0,
  ignoreErrors: [
    'pktAnnotationHighlighter',
    '__puppeteer_evaluation_script__',
    '@safari-extension',
    'vid_mate_check is not defined',
    'ethereum',
    'Non-Error promise rejection captured with value: Object Not Found Matching',
  ],
});

Sentry.configureScope(function (scope) {
  scope.setUser({ id: config.userId });
  scope.setContext('campaign', {
    campaignId: config.messageId,
    metaSiteId: config.metaSiteId,
    locale: config.locale,
  });
});
